import * as React from 'react';
import styled from 'styled-components';

import Box, { BoxProps } from '../box';


type HeaderLayoutProps = {
	isScrolledDown: boolean;
} & BoxProps;

type FooterLayoutProps = {} & BoxProps;

const Root = styled.div`
	position: relative;
	width: 100%;
	height: calc(100vh - 70px);
	padding-top: 32px;
	display: flex;
	flex-flow: column nowrap;
	justify-content: flex-start;
	align-items: flex-start;
`;

const HeaderLayout = styled(({ isScrolledDown, ...rest }) => <Box {...rest} />)`
	position: relative;
	z-index: 10;
	width: 100%;
	padding: 0 32px 30px 32px;

	${(p: HeaderLayoutProps) => p.isScrolledDown && `
		box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.05);
	`}
`;

const ContentLayout = styled.div`
	flex: 1 1 auto;
	width: 100%;
	padding: 0 32px 32px 32px;
	overflow: auto;
`;

const FooterLayout = styled(Box)<FooterLayoutProps>`
	width: 100%;
	height: auto;
	min-height: 90px;
	display: flex;
	flex-flow: row wrap;
	justify-content: flex-start;
	align-items: center;
	padding: 22px 32px;

	& > div {
		margin-right: 10px;
	}

	& > div:last-child {
		margin-right: 0;
	}
`;

export {
	Root,
	HeaderLayout,
	ContentLayout,
	FooterLayout
};
